import GoogleMapReact from "google-map-react";
import LocationMarker from "./LocationMarker";

const Map = ({ center, zoom, data, icon }) => {
  // const Map = ({ center, zoom }) => {
  // console.log(data);
  let marker = data.map((e) => {
    return <LocationMarker lat={e.lat} lng={e.lng} icon={icon} />;
  });

  const defaultProps = {
    center: {
      lat: 1.693,
      lng: 127.894,
    },
    zoom: 2,
  };
  return (
    <div className="map" style={{ width: "100%", height: "100%" }}>
      <GoogleMapReact
        bootstrapURLKeys={{
          key: "AIzaSyBtwb2dbscgYGYlN9y73PFE61BeRYULjXk",
        }}
        defaultCenter={defaultProps.center}
        defaultZoom={defaultProps.zoom}
      >
        {marker}
      </GoogleMapReact>
    </div>
  );
};

export default Map;
